import {
  EWorkZonesManagementRights,
} from "mhc-server/dist/interfaces";

import {IAppRoute} from "../../application/config/IAppRoute";

import {WorkzonesPrepareForOffline} from "../pages/WorkzonesPrepareForOffline/WorkzonesPrepareForOffline";
import WorkzoneOfflinePrepareIcon from "@mui/icons-material/CloudOff";

export const routeWorkzoneOfflinePrepare: IAppRoute = {
  title: 'Prepare CIMs for offline use',
  icon: <WorkzoneOfflinePrepareIcon/>,
  routePath: '/cimt/prepare-offline-use',
  getRoutePath: () => routeWorkzoneOfflinePrepare.routePath,
  menuId: 'CIMs-prepare-for-offline-use',
  userHasAllRights: [EWorkZonesManagementRights.WORKZONES_EDIT],
  userHasAnyOfRights: [],
  render: () => <WorkzonesPrepareForOffline/>,
};
